import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '../UI';

interface DeleteUserModalProps {
  userName: string;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}

export const DeleteUserModal = ({ userName, onConfirm, onClose }: DeleteUserModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      title={t('config-user-delete-title')}
      message={t('config-user-delete-message', { name: userName })}
      warning={t('config-user-delete-warning')}
      cancelLabel={t('config-delete-template-cancel')}
      confirmLabel={t('config-delete-template-confirm')}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};
